import { useEffect, useReducer, useState } from 'react';
import slideTrackReducer, { getDefaultState } from './slideTrackReducer';
import { sumWidthOfChildrenWithGaps } from './utilities';
import { SLIDE_GAP } from './constants';

export default function useSlider(
  slides,
  {
    containerRef, trackRef, containerWidth, isInfinite = false, slidesToShow,
  },
) {
  const [state, dispatch] = useReducer(slideTrackReducer, getDefaultState(slides));
  const [isScrollAllowed, setIsScrollAllowed] = useState(true);

  useEffect(() => {
    const childrenWidth = sumWidthOfChildrenWithGaps([...trackRef.current.children], SLIDE_GAP);
    setIsScrollAllowed(childrenWidth > containerWidth);
  }, [containerWidth, trackRef]);

  useEffect(() => { dispatch({ type: 'slidesUpdated', slides }); }, [slides]);

  useEffect(() => {
    dispatch({
      container: containerRef.current,
      track: trackRef.current,
      type: 'containerResize',
      slidesToShow,
    });
  }, [containerRef, trackRef, containerWidth, slidesToShow]);

  const handleOnSlideLeft = () => dispatch({
    type: 'slideLeft',
    container: containerRef.current,
    slides,
    track: trackRef.current,
    isInfinite,
    slidesToShow,
  });

  const handleOnSlideRight = () => dispatch({
    type: 'slideRight',
    container: containerRef.current,
    slides,
    track: trackRef.current,
    isInfinite,
    slidesToShow,
  });

  const handleOnSlideSelect = (index) => {
    dispatch({
      type: 'setIndex',
      container: containerRef.current,
      index,
      track: trackRef.current,
      slidesToShow,
    });

    return index;
  };

  const handleDetermineNextSlideAfterDrag = (delta, isTouchEvent = false) => dispatch({
    type: 'determineNextSlideAfterDrag',
    delta,
    container: containerRef.current,
    track: trackRef.current,
    isInfinite,
    isTouchEvent,
    slidesToShow,
  });

  return {
    state,
    isScrollAllowed,
    containerWidth,
    containerRef,
    trackRef,
    handleOnSlideLeft,
    handleOnSlideRight,
    handleOnSlideSelect,
    handleDetermineNextSlideAfterDrag,
  };
}
